// Base service name
export const SERVICE_NAME = "GLOBAL_STATES_SERVICE";
